import { Grid, makeStyles, OutlinedInput, Button } from "@material-ui/core";
import React from "react";

const useStyle = makeStyles((theme) => ({
  root: {
    margin: "60px 0",
    width: "100%",
  },
  formField: {
    padding: "15px",
    outline: "black",
    borderRadius: 1,
  },
  submitBtn: {
    color: "black",
    borderRadius: 2,
    boxShadow: "none",
    padding: "10px 75px",
    margin: "20px 0",
    "&:hover": {
      color: theme.palette.secondary.dark,
    },
  },
}));

function SubmissionForm() {
  const classes = useStyle();
  return (
    <div className={classes.root}>
      <p style={{ fontSize: "18px" }}>
        If you would like to make your original work available for free of for
        sale, please provide a brief description of your project, as well as a
        short bio of yourself.
      </p>
      <p style={{ fontSize: "18px" }}>Must have Paypal Account</p>
      <form className={classes.form}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={6}>
            <OutlinedInput
              fullWidth
              placeholder="PayPal Account"
              className={classes.formField}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <OutlinedInput
              fullWidth
              placeholder="Email Address"
              className={classes.formField}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <OutlinedInput
              multiline
              fullWidth
              rows={4}
              placeholder="Author Bio"
              className={classes.formField}
            />
          </Grid>
        </Grid>
        <Button
          color="primary"
          variant="contained"
          className={classes.submitBtn}
        >
          SEND
        </Button>
      </form>
    </div>
  );
}

export default SubmissionForm;
